import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { RouteComponentProps, withRouter } from 'react-router';
import AccountDetails from '../AccountDetails/components/AccountDetails';


type Props = RouteComponentProps<any>

class AccountDetailsView extends Component<Props> {
    render() {
        return (
            <Grid container alignContent="center">
                <Grid item xs={12} sm={12} >
                    <AccountDetails />
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(AccountDetailsView);